<template>
  <div class="user__header" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <backlink/>
    <div class="user__header-title-container">
      <img src="/static/img/pictos/compte.svg" class="">
      <span>Mon compte</span>
    </div>
  </div>
</template>

<script>

  export default {
    name: "StockHeader",
    data() {
      return {

      }
    },
    components: {

    },
    computed: {

    },
    mounted() {

    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .user__header{ background-color: $color3; padding: 65px 20px 0 20px;
    .backlink{ margin-bottom: 5px; }
    .user__header-title-container{ display: flex; align-items: flex-end; }
    img{ width: 100px; margin-left: 35px; }
    span{ color: white; font-family: 'ClanFFBlack'; font-size: 25px; margin-top: 25px; text-transform: uppercase; flex: 1; text-align: right;}
    .search__field{ background-color: transparent; border: 1px solid $color1; font-family: 'ClanPro'; font-size: 14px; color: $color1; width: 100%; outline: none; height: 45px; line-height: 45px; padding: 0 20px; border-radius: 24px; margin-top: 20px; margin-top: 30px; }
  }

</style>



// WEBPACK FOOTER //
// src/components/User/UserHeader.vue